import campaigns from '../../../../static/dummy-data/campaigns'
import audiences from '../../../../static/dummy-data/audiences'
import insights from '../../../../static/dummy-data/insights'
import advertisers from '../../../../static/dummy-data/advertisers'
import helpers from '../../../helpers/functions'

export default {
  clearState ({ commit }) {
    commit('adsets/CLEAR_ADSETS_STATE')
    commit('audiences/CLEAR_AUDIENCE_STATE')
    commit('campaigns/CLEAR_CAMPAIGNS_STATE')
    commit('messages/CLEAR_MESSAGES_STATE')
    commit('reportings/CLEAR_REPORTINGS_STATE')
    commit('advertisers/CLEAR_ADVERTISERS_STATE')
    commit('agencies/CLEAR_AGENCIES_STATE')
    commit('campaigns/CLEAR_CAMPAIGN_INSIGHTS')
    commit('campaigns/CLEAR_ADSETS_INSIGHTS')
    commit('campaigns/CLEAR_ADS_INSIGHTS')
  },
  fetchApiData ({ dispatch, getters }) {
    const user = JSON.parse(localStorage.getItem('outfoxUser'))
    if (!user) return false
      return new Promise(resolve => {
      resolve(dispatch('fetchAdvertisers'))
    })
      .then(res => {
        return dispatch('fetchAgencies')
      })
      .then(res => {
        const setupMode = getters.getSetupMode
        if (!setupMode.status) {
          dispatch('fetchCampaigns')
          dispatch('fetchAudiences')
          dispatch('fetchVideos')
          dispatch('fetchLocations')
        }
        dispatch('fetchErrors')
        return true
      })
      .catch(err => {
        helpers.handleError(err)
        return false
      })
  },
  fetchDataAfterSetupModeOff ({ dispatch }) {
    dispatch('fetchCampaigns')
    dispatch('fetchAudiences')
    dispatch('fetchVideos')
    dispatch('fetchLocations')
  },
  fetchDemoData ({commit}) {
    commit('campaigns/FETCH_CAMPAIGNS', campaigns)
    commit('audiences/FETCH_AUDIENCES', audiences)
    commit('campaigns/ADD_INSIGHT_TO_CAMPAIGN', insights)
    commit('campaigns/ADD_INSIGHT_TO_ADSET', insights)
    commit('campaigns/ADD_INSIGHT_TO_AD', insights)
    commit('advertisers/FETCH_ADVERTISERS', advertisers)
  }
}
